import { render, staticRenderFns } from "./ClinicAvailability.vue?vue&type=template&id=1d771d0c&scoped=true&"
import script from "./ClinicAvailability.vue?vue&type=script&lang=js&"
export * from "./ClinicAvailability.vue?vue&type=script&lang=js&"
import style0 from "./ClinicAvailability.vue?vue&type=style&index=0&id=1d771d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d771d0c",
  null
  
)

export default component.exports